import React from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Switch,
  Box,
  Drawer,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { Link, useNavigate } from "react-router-dom";

const Navbar = ({ darkMode, setDarkMode }) => {
  const navigate = useNavigate();
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleLogout = () => {
    localStorage.removeItem("authToken");
    localStorage.removeItem("authExpiry");
    localStorage.removeItem("userEmail");
    navigate("/");
  };

  // const navItems = [
  //   { text: "Dashboard", path: "/dashboard" },
  //   { text: "Attendance", path: "/attendance" },
  //   { text: "Profile", path: "/profile" },
  //   { text: "Leave", path: "/leave" },
  //   { text: "Task", path: "/task" },
  //   { text: "Logout", action: handleLogout },
  // ];

  const drawer = (
    <Box onClick={handleDrawerToggle} sx={{ textAlign: "center", p: 2 }}>
      <Typography variant="h6" sx={{ my: 2 }}>
        Employee Portal
      </Typography>
      {/* <List>
        {navItems.map((item) => (
          <ListItem
            button
            key={item.text}
            onClick={item.action ? item.action : () => navigate(item.path)}
          >
            <ListItemText primary={item.text} />
          </ListItem>
        ))}
      </List> */}
    </Box>
  );

  return (
    <>
      <AppBar position="static" sx={{ backgroundColor: "primary.main", boxShadow: 3 }}>
        <Toolbar>
          {/* <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2, display: { sm: "none" } }}
          >
            <MenuIcon />
          </IconButton> */}
          <Typography variant="h6" component="div" sx={{ flexGrow: 1, fontWeight: 500 }}>
            Employee Portal
          </Typography>
          {/* <Box sx={{ display: { xs: "none", sm: "flex" }, alignItems: "center" }}>
            {navItems.map((item) =>
              item.action ? (
                <Typography
                  key={item.text}
                  onClick={item.action}
                  sx={{
                    cursor: "pointer",
                    margin: "0 15px",
                    fontWeight: 500,
                    "&:hover": { textDecoration: "underline" },
                  }}
                >
                  {item.text}
                </Typography>
              ) : (
                <Typography
                  key={item.text}
                  component={Link}
                  to={item.path}
                  sx={{
                    textDecoration: "none",
                    color: "inherit",
                    margin: "0 15px",
                    fontWeight: 500,
                    "&:hover": { textDecoration: "underline" },
                  }}
                >
                  {item.text}
                </Typography>
              )
            )}
          </Box> */}
          <Switch checked={darkMode} onChange={() => setDarkMode(!darkMode)} color="default" />
        </Toolbar>
      </AppBar>
      <Box component="nav">
        <Drawer
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{ keepMounted: true }}
          sx={{
            display: { xs: "block", sm: "none" },
            "& .MuiDrawer-paper": { boxSizing: "border-box", width: 240 },
          }}
        >
          {drawer}
        </Drawer>
      </Box>
    </>
  );
};

export default Navbar;
